<template>
	<v-dialog
		v-model="visible"
		:max-width="$vuetify.breakpoint.xsOnly ? 'calc(100vw)': ($vuetify.breakpoint.smAndUp ? (image !== null ? '900px':'600px') : 'calc(90%)')"
		min-width="600"
		persistent
	>
		<v-card :style="loading ? 'height: 400px': ''">
			<v-overlay :value="save_loading" absolute>
				<v-progress-circular
					:size="100"
					:width="5"
					color="grey lighten-5"
					indeterminate
				/>
			</v-overlay>
			<input type="file" class="hidden" ref="updateFile" :accept="file_types.join(',')" capture @change="e => update_files(e)"/>
			<v-alert v-if="error_msg.length !== 0" type="error" class="mb-1">
				{{ error_msg }}
			</v-alert>
			<ProgressGetDataLinear v-if="loading" class="px-5"/>
			<v-row v-if="!loading" class="ma-0">
				<v-col v-if="image.length !== 0 || pdf_items.length !== 0" :cols="$vuetify.breakpoint.xsOnly ? 12: 4" class="pb-6">
					<div style="width: 100%">
						<img v-if="pdf_items && pdf_items.length === 1" :src="pdf_items[0]" width="100%"/>
						<v-carousel v-if="pdf_items && pdf_items.length > 1" v-model="multi_pdf_model" hide-delimiters height="100%" >
							<v-carousel-item
								v-for="(pdf, index) in pdf_items"
								:key="index"
							>
								<img :src="pdf" width="100%"/>
							</v-carousel-item>
						</v-carousel>
						<img v-if="image && image.length !== 0" :src="image" width="100%"/>
						<v-btn small depressed color="#82899B" class="image-remove white--text text-capitalize" @click="onImageRemove()">
							<v-icon small class="mr-1">mdi-close</v-icon>
							Remove
						</v-btn>
						<v-btn small depressed color="#82899B" class="image-zoom white--text text-capitalize" @click.stop="openZoom()">
							<span>Open</span>
						</v-btn>
					</div>
					<v-row v-if="image_loading" class="image-loading fill-height ma-0" align="center" justify="center">
						<v-progress-circular
							:size="50"
							:width="5"
							color="grey lighten-5"
							indeterminate
						/>
					</v-row>
				</v-col>
				<v-col v-if="image_loading && expense && expense.receipt_image && expense.receipt_image.length !== 0" :cols="$vuetify.breakpoint.xsOnly ? 12: 4" class="pb-6">
					<v-row class="image-loading fill-height ma-0" align="center" justify="center">
						<v-progress-circular
							:size="50"
							:width="5"
							color="grey lighten-5"
							indeterminate
						/>
					</v-row>
				</v-col>
				<v-col :cols="(image.length === 0 && pdf_items.length === 0 ) ? 12 : ($vuetify.breakpoint.xsOnly ? 12: 8)" class="pb-6">
					<v-row class="ma-0">
						<span class="expense-field-title">Expense Date</span>
					</v-row>
					<v-row class="ma-0" justify="space-between">
						<DatePicker
							:color="color"
							:lableText="''"
							:isOutlined="true"
							:isIcon="true"
							:dateInit="expenses_date_init"
							@date="expenses_date = $event"
						/>
						<v-btn v-if="!image" depressed outlined color="#00AAFD" height="40" class="text-capitalize px-2" @click="onAddExpenseFile()">
							<v-icon class="mr-1">mdi-plus</v-icon>
							<span class="mr-1">Add file</span>
						</v-btn>
					</v-row>
					<v-row class="ma-0">
						<v-col cols="12" class="pa-0">
							<div class="expense-field-title">Job</div>
							<v-autocomplete
								v-model="job"
								:items="job_items"
								:loading="job_loading"
								:search-input.sync="job_search"
								:color="color"
								:placeholder="`Type to search`"
								background-color="#FAFAFA"
								item-text="display_name"
								item-value="id"
								:item-color="color"
								item-disabled="disabled"
								auto-select-first
								outlined
								dense
								hide-no-data
								hide-details
								return-object
								clearable
								@change="onJobChange($event)"
							/>
						</v-col>
					</v-row>
					<v-row class="ma-0 mt-4">
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-0 pr-2'">
							<div class="expense-field-title">Phase</div>
							<v-select
								v-model="phase"
								:items="phase_items"
								item-text="display_name"
								item-value="id"
								:item-color="color"
								:color="color"
								background-color="#FAFAFA"
								dense
								hide-details
								return-object
								outlined
							/>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 mt-4' : 'pa-0 pl-2'">
							<div class="expense-field-title">Kind</div>
							<KindTreeSelection
								:elementKey="`kind`"
								:color="color"
								:placeholder="'Type to search'"
								:kindParams="onKindParams()"
								:kindSelected="kind_selected"
								:bgColor="'#FAFAFA'"
								@kind-selected="onKindSelected($event)"
							/>
						</v-col>
					</v-row>
					<v-row class="ma-0 mt-4">
						<v-col cols="12" class="pa-0">
							<div class="expense-field-title">Description</div>
							<v-text-field
								v-model="description"
								:color="color"
								background-color="#FAFAFA"
								outlined
								hide-details
								dense
							/>
						</v-col>
					</v-row>
					<v-row class="ma-0 mt-4">
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 6:3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pr-1' : 'pa-0 pr-1'">
							<div class="expense-field-title">Currency</div>
							<v-select
								v-model="currency"
								:items="currencies"
								item-text="code"
								item-value="id"
								:item-color="color"
								:color="color"
								background-color="#FAFAFA"
								dense
								return-object
								outlined
								hide-details
								@change="onCurrencyChange($event)"
							/>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 6:3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pl-1' : 'pa-0 pl-1 pr-2'">
							<div class="expense-field-title">Amount</div>
							<v-text-field
								:value="formatAmount(gross)"
								class="text-right"
								background-color="#FAFAFA"
								dense
								hide-details
								:color="color"
								outlined
								min="0"
								oninput="if(this.value < 0) this.value = 0"
								@change="gross = parseAmount($event)"
							/>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 6:3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pr-1 mt-4' : 'pa-0 pl-2 pr-1'">
							<div class="expense-field-title">Tax</div>
							<v-text-field
								:value="formatAmount(tax_amount)"
								class="text-right"
								background-color="#FAFAFA"
								dense
								hide-details
								:color="color"
								outlined
								:disabled="isTaxDisabled"
								min="0"
								oninput="if(this.value < 0) this.value = 0"
								@change="onTaxAmountChange($event)"
							/>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 6:3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pl-1 mt-4' : 'pa-0 pl-2'">
							<div class="expense-field-title">To Pay</div>
							<v-text-field
								:value="toPay"
								outlined
								disabled
								dense
								hide-details
								background-color="#FAFAFA"
							/>
						</v-col>
					</v-row>
					<v-row class="ma-0 mt-4">
						<v-btn class="text-capitalize px-1" color="#82899B" text @click="onShowToogle()">
							<span v-if="is_show_toogle">Hide tax and markup</span>
							<span v-else>Change tax and markup</span>
						</v-btn>
					</v-row>
					<v-row v-if="is_show_toogle" class="ma-0 mt-2">
						<v-col v-if="isShowMarkup" :cols="$vuetify.breakpoint.xsOnly ? 6:3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-0 pr-1'">
							<div class="expense-field-title">Mark up</div>
							<v-text-field
								:value="formatAmount(mark_up)"
								class="mark-up-field"
								background-color="#FAFAFA"
								append-icon="mdi-percent"
								dense
								hide-details
								:color="color"
								outlined
								min="0"
								oninput="if(this.value < 0) this.value = 0;"
								:disabled="isMarkupDisabled"
								@change="mark_up = parseAmount($event)"
							/>
						</v-col>
						<v-col v-if="isShowMarkup" :cols="$vuetify.breakpoint.xsOnly ? 6:3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-0 pl-1 pr-2'">
							<div class="expense-field-title">Value</div>
							<v-text-field
								:value="valueAmount"
								outlined
								disabled
								dense
								hide-details
								background-color="#FAFAFA"
							/>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-0 pl-1 pr-2'">
							<div class="expense-field-title">Tax Settings</div>
							<v-select
								v-model="tax_setting"
								:items="tax_settings"
								:item-color="color"
								background-color="#FAFAFA"
								dense
								hide-details
								return-object
								outlined
								:color="color"
								@change="onTaxSettingChange"
							/>
						</v-col>
					</v-row>
					<v-row class="ma-0 mt-4">
						<v-btn class="text-capitalize white--text mr-3" color="#00AAFD" depressed :disabled="!isButtonAcive" @click="onSaveExpense()">Save Expense</v-btn>
						<v-btn class="text-capitalize" color="#82899B" depressed outlined @click="onCancel()">Cancel</v-btn>
					</v-row>
				</v-col>
			</v-row>
		</v-card>
		<ReceiptImageView 
			v-if="image_visible"
			:visible="image_visible" 
			:show_image="show_image"
			@image-close="image_visible = false"
		/>
	</v-dialog>
</template>

<script>
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import DatePicker from "@/components/date/date_picker.vue";
import KindTreeSelection from "@/components/kinds/kind_tree_selection.vue";
import ReceiptImageView from "@/views/expenses/receipts/receipt_image_view.vue";
import moment from 'moment';
import config from "@/config.js";
import heic2any from 'heic2any';

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const MAX_FILE_SIZE = 6;
const MAX_SIZE = 1000;
const QUALITY = 0.5;
const FILE_TYPE = ['image/jpeg','image/png','image/heic','image/heic-sequence','application/pdf'];
const SCALE = 1.2;
const PAGE_INIT = 0;
const Max_Distance_Mobile = 48;
const Max_Distance_Window = 68;

export default {
	name:'AttachedExpenseDialog',
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: '',
		},
		currencies: {
			type: Array,
			default: () => [],
		},
		isShowMarkup: {
			type: Boolean,
			default: false,
		},
		isEditMarkup: {
			type: Boolean,
			default: false,
		},
		userId: {
			type: Number,
			default: 0,
		},
		expense: {
			type: Object,
			default: null
		}
	},
	components: {
		ProgressGetDataLinear,
		KindTreeSelection,
		DatePicker,
		ReceiptImageView
	},
	data() {
		const expense = this.expense;
		const expense_date = expense && expense.date
			? expense.date
			: moment().format('YYYY-MM-DD');

		return {
			error_msg: '',
			loading: false,
			save_loading: false,
			error_msg_timer: null,
			file_types: FILE_TYPE,

			image: '',
			image_loading: false,
			image_data: null,

			pdf_items: [],
			multi_pdf_model: 0,
			pdf_data: null,

			file_blob: expense ? expense.file_blob : null,
			file_type: expense ? expense.file_type || '' : '',

			receipt_id: expense ? expense.receipt_id : 0,
			receipt_employee: expense ? expense.receipt_employee : null,
			receipt_image: expense ? expense.receipt_image : '',
			receipt_thumbnail: expense ? expense.receipt_thumbnail : '',

			expenses_date_init: expense_date,
			expenses_date: expense_date,

			job_loading :false,
			job: expense ? expense.job : null,
			job_search: expense && expense.job ? expense.job.display_name : '',
			job_items: expense && expense.job ? [expense.job] : [],

			phase: expense ? expense.phase : null,
			phase_items: expense && expense.phase ? [expense.phase] : [],
			kind_selected: expense ? expense.kind : null,
			kind: expense ? expense.kind : null,
			description: expense ? expense.description || '' : '',

			currency: expense ? this.currencies.find(c => { return c.id === expense.currency.id }) : null,
			gross: expense ? expense.gross : 0,
			tax_amount: expense ? expense.tax_amount : 0,
			has_tax: expense ? (expense.tax_mode === 1 || expense.tax_mode === 4 ? false : true) : true,
			tax_perc: expense ? expense.tax_perc : 0,

			is_show_toogle: true,
			mark_up: expense ? expense.markup : 0,
			tax_setting: expense ? config.tax_settings.find(setting => setting.value === expense.tax_mode) : null,
			tax_settings: config.tax_settings,

			image_visible: false,
			show_image: null
		}
	},
	watch: {
		job_search(value) {
			if (value && value.length >= 1 && (!this.job || value !== this.job.display_name)) {
				this.queryJobs(value);
			}
		},
		gross(new_val, old_val) {
			if (old_val !== new_val) {
				const countries = this.currency.countries || [];
				const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
				if (!country) return;

				this.tax_perc = Number(country.tax_perc);
				this.tax_amount = this.has_tax ? Number(new_val) * this.tax_perc * 0.01 : 0;
						
				/** has_tax=true => Tax applies; has_tax=false => Tax free */
				this.tax_setting = country.has_tax === true ? this.tax_settings.find(tax => { return tax.value === 0 }) : this.tax_settings.find(tax => { return tax.value === 1 });
				this.onTaxSettingChange(this.tax_setting);
			}
		},
		error_msg(value) {
			if (this.error_msg_timer) {
				clearTimeout(this.error_msg_timer);
				this.error_msg_timer = null;
			}

			if (value.length !== 0) {
				this.error_msg_timer = setTimeout(() => {
					this.error_msg = '';
					this.error_msg_timer = null;
				}, 5000);
			}
		}
	},
	computed: {
		toPay() {
			const gross = Number(this.gross) || 0;
			const tax = Number(this.tax_amount) || 0;
			const to_pay = gross + tax;

			return this.formatAmount(to_pay);
		},
		valueAmount() {
			const gross = Number(this.gross) || 0;
			const mark_up_tmp = Number(this.mark_up) || 0;
			const value_amount = gross + (gross * mark_up_tmp * 0.01);

			return this.formatAmount(value_amount);
		},
		isButtonAcive() {
			return this.expenses_date && this.expenses_date.length !== 0
				&& this.job !== null
				&& this.phase !== null
				&& this.kind !== null
				&& this.currency !== null
				&& Number(this.gross) !== 0
				&& this.error_msg.length === 0
				&& !this.save_loading;
		},
		isMarkupDisabled() {
			return !this.isEditMarkup
				|| Number(this.mark_up) < 0
				|| (this.expense && this.expense.once_paid === true)
				|| (this.job && this.job.is_overhead === true)
				|| (this.kind && Number(this.kind.overhead_mode) === 2);
		},
		isTaxDisabled() {
			const tax_setting_value = this.tax_setting ? Number(this.tax_setting.value) : null;
			return tax_setting_value === 1 || tax_setting_value === 4;
		}
	},
	async created() {
		await this.getSettings();

		if (this.expense && this.expense.receipt_image && this.expense.receipt_image.length !== 0) {
			this.getImage(this.expense.receipt_image);
		} else if (this.expense && this.expense.file_blob) {
			this.add_receipt_for_file(this.expense.file_blob);
		}

		if (!this.expense) {
			this.onCreateReceipt();
		}
	},
	mounted() {
		if (this.expense && this.expense.tax_mode !== 1 && this.expense.tax_mode !== 4 && Number(this.expense.tax_amount) === 0) {
			const countries = this.currency.countries || [];
			const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
			if (!country) return;

			this.tax_perc = Number(country.tax_perc);
		}
		if (this.expense && this.expense.tax_mode !== 1 && this.expense.tax_mode !== 4) {
			const countries = this.currency.countries || [];
			const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
			if (!country) return;

			const tax_perc = Number(country.tax_perc);
			if (Number(this.expense.tax_perc) !== tax_perc) {
				this.tax_perc = Number(country.tax_perc);
			}
		}
	},
	methods: {
		getSettings() {
			this.loading = true;
			const usid = this.userId;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);
								const toogle = windata.toogle;
								if (toogle !== null || toogle !== undefined) {
									this.is_show_toogle = toogle;
								}
							}
						}
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.userId;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});			
		},
		onCreateReceipt() {
			this.loading = true;

			const blob = new Blob([''], {type : 'image/jpeg'});
			const url = "/api/expenses/receipts";

			axios
				.post(url, blob, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.receipt_id = data.id;
						this.receipt_employee = data.employee;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		formatAmount(value) {
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(Number(value) || 0);
		},
		parseAmount(value) {
			const amount = Number(String(value).replace(/,/g, ''));

			return Number.isNaN(amount) ? 0 : amount;
		},
		queryJobs(key) {
			this.job_loading = true;

			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));
			params.push("status_groups=" + config.job_status_group_nomal.toString());
			params.push('is_lookup=' + encodeURIComponent(false));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.job_items = data.map(job => {
							const job_name = job.short || job.display_name || job.code;
							const display_name = job_name.includes(job.code) ? job_name : `${job.code} - ${job_name}`;

							return {
								id: job.id,
								code: job.code,
								display_name: display_name,
								is_overhead: job.is_overhead,
								currency: job.currency,
								country: job.country
							};
						});
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.job_loading = false;
				});
		},
		onJobChange(job) {
			if (job) {
				this.getPhases(job.id);

				if (job.currency) {
					this.currency = this.currencies.find(c => { return c.id === job.currency.id });

					if (this.currency ) {
						const countries = this.currency.countries || [];
						const country = countries.find(c => { return job.country && c.id === job.country.id }) || countries[0];
						if (!country) return;

						this.tax_perc = Number(country.tax_perc);
						
						/** has_tax=true => Tax applies; has_tax=false => Tax free */
						this.tax_setting = country.has_tax === true ? this.tax_settings.find(tax => { return tax.value === 0 }) : this.tax_settings.find(tax => { return tax.value === 1 });
						this.onTaxSettingChange(this.tax_setting);
					}
				}

				if (this.kind) {
					this.getMarkup(job.id, this.kind.id);
				}
			}
		},
		getPhases(job_id) {
			axios
				.get(`/api/jobs/${job_id}/phases`, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.phase_items = data;

						if (data.length !== 0) {
							this.phase = data[0];
						} else {
							this.phase = null;
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		onKindParams() {
			const kind_params = {
				select_kinds: true,
				select_items: true,
				expense_kinds: true,
				overhead_mode: 0
			};

			if (this.job) {
				if (this.job.is_overhead === true) {
					kind_params.overhead_mode = 2;
				} else {
					kind_params.overhead_mode = 1;
				}
			}
			
			return kind_params;
		},
		onKindSelected(kind) {
			this.kind = kind;
			this.kind_selected = kind;

			if (kind && this.job) {
				this.getMarkup(this.job.id, kind.id);
			}
		},
		onCurrencyChange(currency) {
			if (currency) {
				const countries = currency.countries || [];
				const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
				if (!country) return;

				this.tax_perc = Number(country.tax_perc);
						
				/** has_tax=true => Tax applies; has_tax=false => Tax free */
				this.tax_setting = country.has_tax === true ? this.tax_settings.find(tax => { return tax.value === 0 }) : this.tax_settings.find(tax => { return tax.value === 1 });
				this.onTaxSettingChange(this.tax_setting);
			}
		},
		onTaxSettingChange(tax_setting) {
			if (!tax_setting) {
				this.has_tax = false;
				this.tax_amount = 0;
				return;
			}

			this.tax_setting = tax_setting;

			if (tax_setting.value === 1 || tax_setting.value === 4) {
				this.has_tax = false;
				this.tax_amount = 0;
			} else {
				this.has_tax = true;
				this.tax_amount = Number(this.gross) * this.tax_perc * 0.01;
			}
		},
		onTaxAmountChange(value) {
			this.tax_amount = this.parseAmount(value);

			if (Number(this.tax_amount) === 0) {
				const tax_free_setting = this.tax_settings.find(setting => setting.value === 1);

				if (tax_free_setting) {
					this.onTaxSettingChange(tax_free_setting);
				}
			}
		},
		getMarkup(job_id, kind_id) {
			let url = "/api/config/rates/markup";

			const params = [];
			params.push("job_id=" + job_id);
			params.push("kind_id=" + kind_id);

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.mark_up = data * 100;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		onAddExpenseFile() {
			this.error_msg = '';
			this.$refs.updateFile.click();
		},
		update_files(e) {
			const file = e.target.files[0];
			this.add_receipt_for_file(file, false);
		},
		add_receipt_for_file(file) {
			if (!file) {
				return;
			}
			if (!this.file_types.includes(file.type)) {
				this.error_msg = `File: ${file.name}, invalid file type`;
				return;
			}
			if (file.size > 1000 * 1000 * MAX_FILE_SIZE) {
				this.error_msg = `File: ${file.name}, over maximum ${MAX_FILE_SIZE}MB size`;
				return;
			}

			console.log('file-before-size:', file.size/1024, 'kb');
			this.image_loading = true;

			const reader = new FileReader();
			reader.readAsDataURL(file); 

			if (file.type === 'application/pdf') {
				reader.onload = readerEvent =>  {
					this.pdf_data = readerEvent.target.result;
					const preview_url = [];
					const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
					loadingTask.promise.then(pdf => {
						for (let index = 0; index < pdf.numPages; index++) {
							pdf.getPage(index + 1).then(page => {
								const scale = SCALE;
								const viewport = page.getViewport({scale: scale});

								const canvas = document.createElement('canvas');
								const context = canvas.getContext('2d');
								canvas.width = viewport.width;
								canvas.height = viewport.height;

								const renderContext = {
									canvasContext: context,
									viewport: viewport
								};
								const renderTask = page.render(renderContext);
								renderTask.promise.then(() => {
									canvas.toBlob(blob => {
										const preview_item_url = URL.createObjectURL(blob);
										preview_url.push(preview_item_url);
									});									
								});
							});
						}
					});

					this.pdf_items = preview_url;
					this.image_loading = false;

					this.file_blob = this._dataURItoBlob(this.pdf_data);
					console.log('file-after-size:', this.file_blob.size /1024, 'kb');

					this.updateImage(this.receipt_id, this.file_blob);
				};
			} else if (file.type === 'image/heic' || file.type === 'image/heic-sequence') {
				heic2any({ blob: file, toType: 'image/jpeg' }).then((blob) => {
					reader.readAsDataURL(blob);

					const preview_url = URL.createObjectURL(blob);
					const my_image = new Image();

					reader.onload = readerEvent =>  {
						my_image.src = readerEvent.target.result;
						my_image.onload = () => {
							this.image_data = this._resizeByQuality(my_image, 1);
							this.image = preview_url;
							this.image_loading = false;

							this.file_blob = this._dataURItoBlob(this.image_data);
							console.log('file-after-size:', this.file_blob.size /1024, 'kb');

							this.updateImage(this.receipt_id, this.file_blob);
						}
					};
				}).catch((e) => {
					this.error_msg = e.message;
				});
			} else {
				const preview_url = URL.createObjectURL(file);
				const my_image = new Image();

				reader.onload = readerEvent =>  {
					my_image.src = readerEvent.target.result;
					my_image.onload = () => {
						this.image_data = this._resizeByQuality(my_image, QUALITY);
						this.image = preview_url;
						this.image_loading = false;

						
						this.file_blob = this._dataURItoBlob(this.image_data);
						console.log('file-after-size:', this.file_blob.size /1024, 'kb');

						this.updateImage(this.receipt_id, this.file_blob);
					}
				};
			}
		},
		getImage(url) {
			this.image_loading = true;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					},
					responseType: 'blob',
				})
				.then((val) => {
					const { status, data } = val;
					if (status === 200) {
						if (data.type === 'application/pdf') {
							const reader = new FileReader();
							reader.readAsDataURL(data);

							reader.onload = readerEvent =>  {
								this.pdf_data = readerEvent.target.result;
								const preview_url = [];
								const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
								loadingTask.promise.then(pdf => {
									for (let index = 0; index < pdf.numPages; index++) {
										pdf.getPage(index + 1).then(page => {
											const scale = SCALE;
											const viewport = page.getViewport({scale: scale});

											const canvas = document.createElement('canvas');
											const context = canvas.getContext('2d');
											canvas.width = viewport.width;
											canvas.height = viewport.height;

											const renderContext = {
												canvasContext: context,
												viewport: viewport
											};
											const renderTask = page.render(renderContext);
											renderTask.promise.then(() => {
												canvas.toBlob(blob => {
													const preview_item_url = URL.createObjectURL(blob);
													preview_url.push(preview_item_url);
												});									
											});
										});
									}
								});

								this.pdf_items = preview_url;
								this.image_loading = false;

								this.file_blob = this._dataURItoBlob(this.pdf_data);
							};
						} else {
							const reader = new FileReader();
							reader.readAsDataURL(data);

							const preview_url = URL.createObjectURL(data);
							const my_image = new Image();

							reader.onload = readerEvent =>  {
								my_image.src = readerEvent.target.result;
								my_image.onload = () => {
									this.image_data = this._resizeByQuality(my_image, 1);
									this.image = preview_url;
									this.image_loading = false;

									this.file_blob = this._dataURItoBlob(this.image_data);
								}
							};
						}
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.image_loading = false;
				});
		},
		updateImage(receipt_id, blob) {
			this.save_loading = true;
			const url = `/api/expenses/receipts/${receipt_id}/image`;

			axios
				.put(url, blob, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.file_type = data.image_type ? data.image_type : '';
						this.receipt_image = data.image ? data.image : '';
						this.receipt_thumbnail = data.thumbnail ? data.thumbnail : '';
						this.save_loading = false;
					} else {
						this.error_msg = reason;
						this.save_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.save_loading = false;
				});
		},
		onImageRemove() {
			const url = `/api/expenses/receipts/${this.receipt_id}/image`;

			axios
				.delete(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason} = val.data;
					
					if (status == "OK") {
						this.image = '';
						this.image_data = null;
						this.image_loading = false;
						this.pdf_items = [];
						this.pdf_data = null;
						this.multi_pdf_model = 0;
						this.file_blob = null;
						this.file_type = '';
						this.receipt_image = '';
						this.receipt_thumbnail = '';
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		openZoom() {
			const url = URL.createObjectURL(this.file_blob);
			this._showImage(this.file_blob, url);
		},
		_showImage(data, url) {
			if (data.type === 'application/pdf') {
				const reader = new FileReader();
				reader.readAsDataURL(data); 
				reader.onload = readerEvent =>  {
					const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
					loadingTask.promise.then(pdf => {
						const preview_url = [];
						let page_total = pdf.numPages;

						for (let index = 0; index < pdf.numPages; index++) {
							pdf.getPage(index + 1).then(page => {
								const scale = SCALE;
								const viewport = page.getViewport({scale: scale});

								const canvas = document.createElement('canvas');
								const context = canvas.getContext('2d');
								canvas.width = viewport.width;
								canvas.height = viewport.height;

								const renderContext = {
									canvasContext: context,
									viewport: viewport
								};

								const renderTask = page.render(renderContext);
								renderTask.promise.then(() => {
									canvas.toBlob(blob => {
										const preview_item_url = URL.createObjectURL(blob);
										preview_url.push(preview_item_url);
										page_total -= 1;

										if (page_total === PAGE_INIT) {
											let image_width = 0;
											let image_height = 0;

											const isMobile = window.innerWidth < 600
											if (isMobile) {
												/** this.$vuetify.breakpoint.width <= 600 */
												const max_width = this.$vuetify.breakpoint.width - Max_Distance_Mobile;
												image_width = max_width;
												image_height = max_width * (viewport.height / viewport.width);

											} else {
												/** this.$vuetify.breakpoint.width >= 960 */
												const max_height = this.$vuetify.breakpoint.height - Max_Distance_Window;
												image_width = max_height * (viewport.width / viewport.height);
												image_height = max_height;
											}
											const show_image = {
												image: preview_url,
												image_width: image_width,
												image_height: image_height,
												url: url
											};

											this.show_image = show_image;
											this.image_visible = true
										}
									});									
								});
							});
						}
					});
				};
							
			} else {
				const my_image = new Image();
				const preview_item_url = URL.createObjectURL(data);
				my_image.src = preview_item_url;

				my_image.onload = () => {
					let image_width = 0;
					let image_height = 0;

					if (this.$vuetify.breakpoint.smAndUp) {
						const max_height = this.$vuetify.breakpoint.height - Max_Distance_Window;
						image_width = max_height * (my_image.width / my_image.height);
						image_height = max_height;
					} else {
						/* 48 = padding-left-24px + padding-right-24px */
						const max_width = this.$vuetify.breakpoint.width - Max_Distance_Mobile;
						image_width = max_width;
						image_height = max_width * (my_image.height / my_image.width);
					}

					const show_image = {
						image: [preview_item_url],
						image_width: image_width,
						image_height: image_height,
						url: url
					};

					this.show_image = show_image;
					this.image_visible = true;
				}
			}
		},
		onShowToogle() {
			this.is_show_toogle = !this.is_show_toogle;

			const win_setup_obj = {
				toogle: this.is_show_toogle,
			};
			const win_setup_str = JSON.stringify(win_setup_obj);

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onSaveExpense() {
			if (this.job && this.kind && this.kind.overhead_mode === 1 && !this.job.is_overhead) {
				this.error_msg = "You can't use an overhead kind on a client job";
				return ;
			} else if (this.job && this.kind && this.kind.overhead_mode === 0 && this.kind.show_over === 0 && this.job.is_overhead) {
				this.error_msg = "You can't use a client kind on an overhead job";
				return ;
			};
			if (this.receipt_id === 0) return;

			this.save_loading = true;
			const params = this._getReceiptParam();
			const url = "/api/expenses/receipts/" + this.receipt_id;

			axios
				.put(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const expense_object = {
							receipt_id: data.id,
							index: this.expense ? this.expense.index : undefined,
							date: data.date,
							currency: data.currency,
							amount: data.value,
							description: data.desc,
							phase: data.phase,
							job: data.job,
							kind: data.kind,
							gross: data.value,
							tax_mode: data.tax_mode,
							tax_setting: this.tax_settings.find(setting => { return setting.value === data.tax_mode }),
							tax_amount: Number(Number(data.tax_amount).toFixed(2)),
							tax_perc: Number(Number(data.tax_perc).toFixed(2)),
							markup: Number(Number(data.markup_perc).toFixed(2)),
							value_fc: Number(Number(data.markup_value).toFixed(2)),
							file_type: data.image_type,
							file_blob: this.file_blob,
							select: this.expense ? this.expense.select === true : false,
							receipt_employee: data.employee,
							receipt_image: data.image ? data.image : '',
							receipt_thumbnail: data.thumbnail ? data.thumbnail : '',
							once_paid: false
						};

						this.$emit('expense', expense_object)
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.save_loading = false;
				});
		},
		onCancel() {
			if (this.expense) {
				const expense_object = {
					receipt_id: this.expense ? this.expense.receipt_id : this.receipt_id,
					index: this.expense ? this.expense.index : undefined,
					date: this.expenses_date,
					currency: this.currency,
					amount: this.parseAmount(this.toPay),
					description: this.description,
					phase: this.phase,
					job: this.job,
					kind: this.kind,
					gross: this.gross,
					tax_mode: this.tax_setting ? this.tax_setting.value : (this.tax_amount !== 0 ? 0 : 1),
					tax_setting: this.tax_setting ? this.tax_setting : (this.tax_amount !== 0 ? this.tax_settings[0] : this.tax_settings[1]),
					tax_amount: Number(this.tax_amount.toFixed(2)),
					tax_perc: this.taxPerc,
					markup: this.mark_up,
					value_fc: this.parseAmount(this.valueAmount),
					file_type: this.file_type,
					file_blob: this.file_blob,
					select: this.expense ? this.expense.select === true : false,
					receipt_employee: this.receipt_employee,
					receipt_image: this.receipt_image,
					receipt_thumbnail: this.receipt_thumbnail,
					once_paid: false
				};

				this.$emit('expense', expense_object);
				this.$emit('close');
			} else {
				if (this.receipt_id === 0) return;

				this._deleteReceipt(this.receipt_id);
			}
		},
		_getReceiptParam() {
			const update_receipt = {
				employee_id: this.receipt_employee.id,
				desc: this.description,
				date: this.expenses_date,
				currency_id: this.currency.id,
				gross: this.gross,
				has_tax: this.has_tax ? 1 : 0,
				job_id: this.job.id,
				phase_id: this.phase.id,
				kind_id: this.kind.id,
				tax_mode: this.tax_setting ? this.tax_setting.value : (this.tax_amount !== 0 ? 0 : 1),
				tax_perc: this.tax_perc,
				tax_amount: Number(this.tax_amount.toFixed(2)),
				markup_perc: this.mark_up,
				value: this.parseAmount(this.valueAmount)
			};

			return update_receipt;
		},
		_deleteReceipt(receipt_id) {
			const url = "/api/expenses/receipts/" + receipt_id;
			
			axios
				.delete(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason} = val.data;
					
					if (status == "OK") {
						this.$emit('close');
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_dataURItoBlob(dataURI) {
			// https://stackoverflow.com/questions/6850276/how-to-convert-dataurl-to-file-object-in-javascript
			// convert base64 to raw binary data held in a string
			// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
			var byteString = atob(dataURI.split(',')[1]);

			// separate out the mime component
			var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

			// write the bytes of the string to an ArrayBuffer
			var ab = new ArrayBuffer(byteString.length);
			var ia = new Uint8Array(ab);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			return new Blob([ab], {type: mimeString});
		},
		_resizeByWidth(img) {
			const ratio = img.width / img.height;
			let canvas_width = 0;
			let canvas_height = 0;
			
			if (ratio >= 1) {
				if (img.width > MAX_SIZE) {
					canvas_width = MAX_SIZE;
					canvas_height = MAX_SIZE / ratio;
				} else {
					canvas_width = img.width;
					canvas_height = img.height;
				}
			} else {
				if (img.height > MAX_SIZE) {
					canvas_height = MAX_SIZE
					canvas_width = MAX_SIZE * ratio;
				} else {
					canvas_width = img.width;
					canvas_height = img.height;
				}
			}
			const canvas = document.createElement('canvas');
			canvas.width = canvas_width;
			canvas.height = canvas_height;
			const context = canvas.getContext('2d');
			context.drawImage(img,0,0, canvas_width, canvas_height);
			return canvas.toDataURL("image/jpeg");
		},
		_resizeByQuality(img, q) {
			const canvas = document.createElement('canvas');
			canvas.width = img.width;
			canvas.height = img.height;
			const context = canvas.getContext('2d');
			context.drawImage(img,0,0, img.width, img.height);
			return canvas.toDataURL("image/jpeg", q);
		},
	}
}
</script>
<style lang="scss" scoped>
.expense-field-title {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #37495F;
}
.expense-optional-text {
	font-family: Roboto;
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	text-align: right;
	color: #37495F;
}
.hidden {
	display: none;
}
.image-loading {
	background: #C4C4C4;
}
.image-remove {
	float: left;
	top: -36px;
	left: 0px;
}
.image-zoom {
	float: right;
	top: -36px;
	right: 0px;
}
.mark-up-field ::v-deep .v-input__append-inner .v-icon {
	font-size: 16px;
}
</style>
